import { DealProvider } from "@/contexts/DealContext";
import MainLayout from "@/layouts/MainLayout";
import DealSummaryPage from "@/pages/DealSummaryPage";
import SummaryPage from "@/pages/LoanSummaryPage";
import ReviewPage from "@/pages/ReviewPage";
import UploadPage from "@/pages/UploadPage";
import WelcomePage from "@/pages/WelcomePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import WelcomePage from "@/pages/WelcomePage";
// import DocumentUploadPage from "@/pages/DocumentUploadPage";
// import ProcessingPage from "@/pages/ProcessingPage";
// import ReviewPage from "@/pages/ReviewPage";
// import SummaryPage from "@/pages/SummaryPage";
const AppRoutes = () => {
  return (
    <Router>
      <DealProvider>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<WelcomePage />} />
            <Route path="upload" element={<UploadPage />} />
            <Route path="loan/:loanId" element={<SummaryPage />} />
            <Route path="summary" element={<DealSummaryPage />} />
            <Route path="review" element={<ReviewPage />}>
              <Route index element={<ReviewPage />} />
              <Route path="loan/:loanId" element={<ReviewPage />}>
                <Route path=":keyName" element={<ReviewPage />} />
              </Route>
            </Route>
            {/* <Route path="summary" element={<SummaryPage />} /> */}
          </Route>
        </Routes>
      </DealProvider>
    </Router>
  );
};

export default AppRoutes;
